import { createContext } from 'react';

interface QueryParamsContextType {
  params: URLSearchParams;
  setParams: (newParams: URLSearchParams) => void;
}

// This is needed to share state between components that uses useQueryParams hook
export const QueryParamsContext = createContext<QueryParamsContextType>({
  params: new URLSearchParams(),
  setParams: () => {
    throw new Error('setParams is not implemented');
  },
});
